import React from 'react';
import HeaderWithSubHeader from "../components/HeaderWithSubHeader";
import PrevAndNextComponent from "../components/PrevAndNextComponent";

const Survey = ({step, steps, handleNext, handleBack, activeStep, handleSetStepSummary}) => {

    const handleLocalNext = () => {
        handleNext();
    };

    return (
        <div style={{display: "flex", justifyContent: "flex-start", flexDirection: "column", textAlign: "left", fontSize: "24px"}}>
            <HeaderWithSubHeader steps={steps} step={step}/>
            <br/>
            <br/>

            <PrevAndNextComponent steps={steps} activeStep={activeStep} handleBack={handleBack} handleLocalNext={handleLocalNext} />

        </div>
    );
};

export default Survey;